<template>
  <div class="">
    <!-- {{ $route.params }} -->
    <div class="d-flex d-sm-none flex-row align-center mx-1">
      <v-text-field
        v-model="searchInput"
        hide-details
        outlined
        dense
        placeholder="Search All Conditions"
        @keyup.enter.native="doSearch()"
        ref="input"
      ></v-text-field>
      <v-btn
        small
        outlined
        class="ml-2"
        color="primary"
        :disabled="!searchInput"
        @click="doSearch()"
        >Go</v-btn
      >
    </div>
    <div class="text-h4" v-if="!category && !name && !search">
      Ocular Conditions
    </div>

    <v-fade-transition>
      <conditions-for-category
        v-if="category || search"
        :category="category"
        :search="search"
        class="ma-2"
      ></conditions-for-category>

      <condition-details
        v-else-if="name && catJson"
        :name="name"
        :conditionTypes="catJson.conditionTypes"
        :sectionOrder="catJson.sectionOrder"
        :sectionObjects="catJson.sectionObjects"
        :specialFields="catJson.specialFields"
        class="ma-2"
      ></condition-details>
    </v-fade-transition>

    <v-alert v-if="error" type="error" class="ma-2"
      >Sorry, there was an api error</v-alert
    >
  </div>
</template>

<script>
import GetJsonMixin from "@/assets/js/GetJsonMixin";

export default {
  name: "Conditions",
  mixins: [GetJsonMixin],
  components: {
    ConditionsForCategory: () =>
      import("@/components/conditionsStuff/ConditionsForCategory"),
    ConditionDetails: () =>
      import("@/components/conditionsStuff/ConditionDetails"),
    // ConditionsContents: () => import("@/components/conditionsStuff/ConditionsContents.vue"),
  },
  data: () => ({
    category: null,
    name: null,
    breadcrumbCategory: null,
    search: null,
    searchInput: null,
    catJson: null,
    error: null,
    loading: false,
  }),
  computed: {},
  methods: {
    doSearch() {
      if (this.searchInput) {
        this.$router.push({
          path: "/ocular-conditions/search/" + encodeURI(this.searchInput),
        });
        this.$refs.input.reset();
      }
      // ! if changing this, remember there is also a search function in /components/conditionsMenuBtns (for larger screens)
    },
  },

  mounted() {
    let q = this.$route.query.q;
    let params = this.$route.params;
    this.name = params?.name ? params.name : null;
    this.category = params?.category ? params.category : null;
    this.search = params?.search ? params.search : null;
    if (q) this.search = q;

    if (!this.name && !this.category && !this.search)
      this.category = "eyelid-eyelashes";
    this.getJSON("dzCategories", "catJson"); // in the mixin
  },
  created() {},
};
</script>

<style scoped>
.titlebar {
  border: 1px solid #bfd5e5 !important;
}
</style>
